import LoginModalContainer from './LoginModalContainer';

/*
* 로그인 모달
*/
export default LoginModalContainer;